'use strict';

const applyDocumentTheme = mode => {
	if (typeof document === 'undefined') return;
	const root = document.documentElement;
	const next = mode === 'dark' ? 'dark' : 'light';
	root.dataset.theme = next;
	root.style.colorScheme = next;
};

module.exports = {
	applyDocumentTheme
};
